import React from "react";
import styles from "../../assets/styles/loan.module.css";
import { formatIndianCurrencyFormat } from "../../utils/aditiUtil";
import { Box, Grid, Typography } from "@mui/material";
import { isMobile, isTablet } from "../../utils/responsiveUtil";
import AppColors from "../../utils/appColors";

function EmiCalculatorResult({ flatIntEmi, reducingIntEmi }) {
  return (
    <Box
      className={styles.emiRightSecWrapper}
      ml={isTablet ? 0 : 4}
      mt={isTablet ? 6 : 0}
    >
      <table className={styles.emiCalculatorTable}>
        <colgroup>
          <col width={"30%"} />
          <col width={"30%"} />
          <col
            width={isMobile ? "35%" : "30%"}
            style={{
              backgroundColor: AppColors.yellow04,
            }}
          />
        </colgroup>
        <tr>
          <td></td>
          <td className={styles.emiResultTitle}> Flat Interest rate</td>
          <td
            className={styles.emiResultTitle}
            style={{
              paddingTop: "10px",
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
            }}
          >
            Reducing Interest rate
          </td>
        </tr>

        <tr>
          <td className={styles.emiResultHeader}>Monthly EMI:</td>
          <td className={styles.emiResultAmounts}>
            ₹ {formatIndianCurrencyFormat(flatIntEmi?.emi || 0)}
          </td>
          <td className={styles.emiResultAmounts}>
            ₹ {formatIndianCurrencyFormat(reducingIntEmi.emi || 0)}
          </td>
        </tr>

        <tr>
          <td className={styles.emiResultHeader}>Total Interest:</td>
          <td className={styles.emiResultAmounts}>
            ₹ {formatIndianCurrencyFormat(flatIntEmi?.totalInt || 0)}
          </td>
          <td className={styles.emiResultAmounts}>
            ₹ {formatIndianCurrencyFormat(reducingIntEmi?.totalInt || 0)}
          </td>
        </tr>

        <tr>
          <td className={styles.emiResultHeader}>Total Amount:</td>
          <td className={styles.emiResultAmounts}>
            ₹ {formatIndianCurrencyFormat(flatIntEmi?.totalAmt || 0)}
          </td>
          <td className={styles.emiResultAmounts}>
            ₹ {formatIndianCurrencyFormat(reducingIntEmi?.totalAmt || 0)}
          </td>
        </tr>

        <tr>
          <td></td>
          <td></td>
          <td
            className={styles.emiResultAmounts}
            width={"30%"}
            style={{
              padding: "16px 6px",

              borderBottomLeftRadius: "10px",
              borderBottomRightRadius: "10px",
            }}
          >
            <span style={{ fontWeight: 500 }}>Save</span> ₹{" "}
            {formatIndianCurrencyFormat(
              flatIntEmi?.totalAmt - reducingIntEmi?.totalAmt || 0
            )}
          </td>
        </tr>
      </table>
    </Box>
  );
}

export default EmiCalculatorResult;
